import script from "./NeutralIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./NeutralIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__